import { Select, MenuItem, Button, Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import classes from "./reports.module.css";
import { Grid, Box, CircularProgress } from "@mui/material";
import { StyledMenu } from "../../../components/styledMenu";
import SearchableMemberSelect from "../../../components/SearchableMemberSelect";
import {
  ExcelIcon,
  PdfIcon,
  DatePickerCalendarIcon,
} from "../../../components/Icons";
import { TEAM_LIST } from "../../../api-calls/api-urls";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { teamsList } from "../../../Redux/actions/team-actions";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { toast } from "react-toastify";

import {
  authApi,
  getAuthorizationHeader,
  getDownloadErrorMessage,
} from "../../../api-calls/user-requests";
import AlertBox from "../../../components/AlertBox";

const ReportIndex = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reportType, setReportType] = useState("0");
  const [selectedTeam, setSelectedTeam] = useState("0");
  const [teamMembers, setTeamMembers] = useState([]);
  const isRouteReport = reportType === "history";
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [loading,setLoading]=useState(false)
  const [downloading, setDownloading] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const teamList = useSelector((state) => state.teams.teamsList);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getData = async () => {
   try {
    const { data } = await authApi.get(TEAM_LIST, {
      headers: { Authorization: getAuthorizationHeader() },
    });
    console.log(data);
    dispatch(teamsList(data));
   } catch (error) {
    console.log(error);
   }
  };

  useEffect(() => {
    getData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = async (event) => {
    setReportType(event.target.value);
    setTeamMembers([]);
  };

  const handleViewReport = () => {
    setLoading(true);

    // Validate that toDate is not before fromDate
    if (dayjs(toDate).isBefore(dayjs(fromDate))) {
      setErrorMessage("To date cannot be before the from date.");
      setLoading(false);
      setError(true);
      return; // Exit early if the dates are invalid
    }

    if (teamMembers.every((member) => member.playerDetails)) {
      if (reportType === "history") {
        const teamMember = teamMembers[0];
        navigate(`/maps/view-route/${teamMember?.playerDetails?._id}`, {
          state: {
            date: dayjs(fromDate).format("MM-DD-YYYY"),
            userName: teamMember.user_name,
            teamName: selectedTeam.team_name,
            userPhoto: teamMember.playerDetails?.photo || null,
          },
        });
      } else {
        const mobiles = teamMembers.map((member) => member.mobile_number).join(",");
        navigate(
          `/reports/view-report?mb=${mobiles}&id=${
            selectedTeam?.user_id
          }&sd=${dayjs(fromDate).format("MM-DD-YYYY")}&ed=${dayjs(
            toDate
          ).format("MM-DD-YYYY")}&tp=${reportType}`
        );
      }
      setLoading(false);
    } else {
      setErrorMessage("Player Still Not Registered");
      setLoading(false);
      setError(true);
    }
  };


  const handleChangeTeam = async (event) => {
    setSelectedTeam(event.target.value);
    setTeamMembers([]);
  };

  const handleChangeRouteReportMember = async (event) => {
    setTeamMembers([event.target.value]);
  };

  const handleDownload = async (value) => {
    // Close the PDF/Excel popover immediately so a second click can't queue
    // another download while the first one is still in flight.
    handleClose();

    if (downloading) return;

    if (teamMembers.length > 0 && teamMembers.every((member) => member.playerDetails)) {
      setDownloading(true);
      try {
        const mobiles = teamMembers.map((member) => member.mobile_number).join(",");
        // "history" (Route Report) hits a different backend endpoint (/route-report,
        // the GPS timeline) than its dropdown value implies, and is single-day (no
        // end date) — use ISO YYYY-MM-DD here specifically, since the date-range
        // reports' MM-DD-YYYY format is misparsed a day off by the backend's IST
        // date utilities (a separate, pre-existing issue not touched here).
        // The expense report also uses ISO YYYY-MM-DD, for the same reason as
        // the route report: MM-DD-YYYY is parsed a day early by the backend's
        // IST date utilities. Attendance and Task keep the old format so their
        // existing (pre-existing, separately tracked) behaviour is unchanged.
        const rangeDateFormat =
          reportType === "expense" ? "YYYY-MM-DD" : "MM-DD-YYYY";
        const url = isRouteReport
          ? `report/route-report/download/${mobiles}/${
              selectedTeam?.user_id
            }?date=${dayjs(fromDate).format("YYYY-MM-DD")}&type=${value}`
          : `report/${reportType}-report/download/${mobiles}/${
              selectedTeam?.user_id
            }?startDate=${dayjs(fromDate).format(
              rangeDateFormat
            )}&endDate=${dayjs(toDate).format(rangeDateFormat)}&type=${value}`;

        const { data } = await authApi.get(url, {
          headers: { Authorization: getAuthorizationHeader() },
          responseType: "blob",
        });

        const mimeType =
          value === "pdf"
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([data], { type: mimeType });
        const blobUrl = URL.createObjectURL(blob);

        const nameSuffix =
          teamMembers.length === 1
            ? teamMembers[0].user_name
            : `${teamMembers.length} members`;
        const filePrefix = isRouteReport ? "route" : reportType;
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download =
          value === "pdf"
            ? `${filePrefix}Report(${nameSuffix}).pdf`
            : `${filePrefix}Report(${nameSuffix}).xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
        toast.success("Report downloaded successfully");
      } catch (error) {
        console.log(error);
        toast.error(await getDownloadErrorMessage(error));
      } finally {
        setDownloading(false);
      }
    } else {
      setErrorMessage("Player Still Not Registered");
      setError(true);
    }
  };

  return (
    <div>
      <Card className={classes.reportMainCard}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <Select
              sx={{
                width: "100%",
                background: "white",
                color: reportType !== "0" ? "black" : "#b3b3b3",
              }}
              value={reportType}
              size="small"
              onChange={handleChange}
            >
              <MenuItem value={"0"} style={{ display: "none" }}>
                Select Report
              </MenuItem>
              <MenuItem value={"attendance"}>Attendance Report</MenuItem>
              <MenuItem value={"task"}>Task Report</MenuItem>
              <MenuItem value={"history"}>Route Report</MenuItem>
              <MenuItem value={"expense"}>Expense Report</MenuItem>
            </Select>
          </Grid>
          {reportType && reportType !== "0" && (
            <>
              <Grid item xs={12} sm={6} md={3}>
                <Select
                  sx={{
                    width: "100%",
                    background: "white",
                    color: selectedTeam !== "0" ? "black" : "#b3b3b3",
                  }}
                  value={selectedTeam}
                  size="small"
                  onChange={handleChangeTeam}
                >
                  <MenuItem value={"0"} style={{ display: "none" }}>
                    Select Team
                  </MenuItem>
                  {teamList &&
                    teamList?.length > 0 &&
                    teamList.map((team) => {
                      return <MenuItem value={team} key={team._id}>{team.team_name}</MenuItem>;
                    })}
                </Select>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                {isRouteReport ? (
                  <Select
                    sx={{
                      width: "100%",
                      background: "white",
                      color: teamMembers.length > 0 ? "black" : "#b3b3b3",
                    }}
                    value={teamMembers[0] || "0"}
                    size="small"
                    onChange={handleChangeRouteReportMember}
                  >
                    <MenuItem value={"0"} style={{ display: "none" }}>
                      Select Player
                    </MenuItem>
                    {selectedTeam &&
                      selectedTeam !== "0" &&
                      selectedTeam.team_members?.length > 0 &&
                      selectedTeam.team_members.map((member) => {
                        return (
                          <MenuItem value={member} key={member._id}>{member?.user_name}</MenuItem>
                        );
                      })}
                  </Select>
                ) : (
                  <SearchableMemberSelect
                    members={
                      selectedTeam && selectedTeam !== "0"
                        ? selectedTeam.team_members || []
                        : []
                    }
                    // Former members stay selectable: their historical
                    // attendance, tasks and expenses are still reportable.
                    formerMembers={
                      selectedTeam && selectedTeam !== "0"
                        ? selectedTeam.removed_members || []
                        : []
                    }
                    value={teamMembers}
                    onChange={setTeamMembers}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box className="datePickerContainer">
                  <DesktopDatePicker
                    label="Start Date"
                    className={`${classes.datePickerInput}`}
                    slots={{
                      openPickerIcon: DatePickerCalendarIcon,
                    }}
                    slotProps={{ textField: { size: 'small' } }}
                    value={fromDate}
                    onChange={(newValue) => setFromDate(newValue)}
                    required
                    format="DD/MM/YYYY"
                    sx={{ width: '100%', bgcolor: 'white' }}
                  />
                </Box>
              </Grid>
              {reportType !== "history" && (
                <Grid item xs={12} sm={6} md={3}>
                  <Box className="datePickerContainer">
                    <DesktopDatePicker
                      label="End Date"
                      className={`${classes.datePickerInput}`}
                      slots={{
                        openPickerIcon: DatePickerCalendarIcon,
                      }}
                      slotProps={{ textField: { size: 'small' } }}
                      value={toDate}
                      onChange={(value) => setToDate(value)}
                      required
                      format="DD/MM/YYYY"
                      sx={{ width: '100%', bgcolor: 'white' }}
                    />
                  </Box>
                </Grid>
              )}
            </>
          )}

        </Grid>
      </LocalizationProvider>

        <Box sx={{ display: 'flex', gap: '20px', mt: 3 }}>
          <Box sx={{ width: { xs: '100%', sm: '30%', md: '20%' } }}>
            <Button
              className={classes.viewReportBtn}
              variant="contained"
              disabled={
                reportType === "0" ||
                selectedTeam === "0" ||
                teamMembers.length === 0 ||
                !fromDate
              }
              fullWidth
              sx={{
                backgroundColor: "#227dc3",
                color: "white",
                '&:hover': {
                  backgroundColor: "#1a5f97",
                },
                '&.Mui-disabled': {
                  backgroundColor: 'rgba(0, 0, 0, 0.12) !important',
                  color: 'rgba(0, 0, 0, 0.26) !important',
                }
              }}
              onClick={handleViewReport}
            >
              View Report
            </Button>
          </Box>
          {reportType && reportType !== "0" && (
            <Box sx={{ width: { xs: '100%', sm: '30%', md: '20%' } }}>
              <Button
                className={classes.viewReportBtn}
                fullWidth
                variant="outlined"
                disabled={
                  reportType === "0" ||
                  selectedTeam === "0" ||
                  teamMembers.length === 0 ||
                  !fromDate ||
                  (!isRouteReport && !toDate) ||
                  downloading
                }
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                startIcon={downloading ? <CircularProgress size={16} color="inherit" /> : null}
                sx={{
                  borderColor: "#227dc3",
                  color: "#227dc3",
                  '&:hover': {
                    borderColor: '#1a5f97',
                    backgroundColor: 'rgba(34, 125, 195, 0.04)',
                  },
                  '&.Mui-disabled': {
                    borderColor: 'rgba(0, 0, 0, 0.12) !important',
                    color: 'rgba(0, 0, 0, 0.26) !important',
                  }
                }}
              >
                {downloading ? "Downloading..." : "Download Report"}
              </Button>
              <StyledMenu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                sx={{
                  width: "100%",
                }}
              >
                <MenuItem onClick={() => handleDownload("pdf")}>
                  <PdfIcon /> Download report as PDF
                </MenuItem>
                <MenuItem onClick={() => handleDownload("excel")}>
                  <ExcelIcon /> Download report as Excel
                </MenuItem>
              </StyledMenu>
            </Box>
          )}
        </Box>
      </Card>
      {errorMessage && error && (
        <AlertBox type="error" message={errorMessage} stateName={setError} />
      )}
    </div>
  );
};

export default ReportIndex;
